/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the router package.
 */

import {Version} from '@angular/core';

/**
 * @publicApi
 */
export const VERSION = new Version('15.1.0');
